export const isJSON: (text: string) => boolean = (text) => {
  if (typeof text !== 'string') {
    return false;
  }
  try {
    JSON.parse(text);
    return true;
  } catch (error) {
    return false;
  }
};

export const inIframe = () => {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
};

export function getUserDataFromCookie() {
  const cookieString = document.cookie;
  const cookies = cookieString.split(';');

  const userDataCookie = cookies.find((cookie) =>
    cookie.trim().startsWith('userData=')
  );

  if (userDataCookie) {
    const userDataString = userDataCookie.split('=')[1];
    try {
      const userData = JSON.parse(decodeURIComponent(userDataString));
      return userData;
    } catch (error) {
      console.error('Error parsing userData cookie:', error);
      return null;
    }
  } else {
    return null;
  }
}

export function deleteCookie(name, path, domain) {
  // Set the cookie expiration date to the past
  const expires = 'expires=Thu, 01 Jan 1970 00:00:00 UTC;';
  // Set the cookie value to empty
  const cookieValue = name + '=;';
  // Set the path attribute
  const pathValue = path ? 'path=' + path + ';' : '';
  // Set the domain attribute
  const domainValue = domain ? 'domain=' + domain + ';' : '';

  // Delete the cookie for the given path and domain
  document.cookie = cookieValue + expires + pathValue + domainValue;
}

// Function to get the domain parts
export function getDomainParts(domain) {
  const parts = domain.split('.');
  const domains = [];
  for (let i = parts.length - 1; i >= 0; i--) {
    domains.push(parts.slice(i).join('.'));
  }
  return domains;
}

export function deleteCookieOnAllDomains(name, childDomain: string) {
  getDomainParts(childDomain).forEach((domainPart) => {
    deleteCookie(name, '/', domainPart);
    deleteCookie(name, '', domainPart);
  });
}
